<template>
  <div id="boxes-filter">
    <dropdown-card
      class="dropdown-card"
      height="fit-content"
      :isOpen="cardIsOpen"
    >
      <template slot="header">
        <div class="header-part">
          <div class="header-icon">
            <img src="/static/icons/filter-icon.svg" />
          </div>
          <div class="header-title">
            {{ $t("storeScreen.boxesFilter.header") }}
          </div>
        </div>
      </template>
      <template>
        <template v-if="isLoading"></template>
        <template v-if="!isLoading">
          <div class="filter-body">
            <div class="filter-wrapper">
              <div class="filter double-filter">
                <div class="position">
                  <basic-select
                    :placeholderText="
                      $t('storeScreen.boxesFilter.body.placement')
                    "
                    :label="$t('storeScreen.boxesFilter.body.placement')"
                    class="placement"
                    v-model="placement"
                  >
                    <basic-select-item
                      :value="0"
                      :text="
                        $t('storeScreen.boxesFilter.body.placement.washed')
                      "
                    />
                    <basic-select-item
                      :value="1"
                      :text="
                        $t('storeScreen.boxesFilter.body.placement.fromPartner')
                      "
                    />
                    <basic-select-item
                      :value="2"
                      :text="
                        $t('storeScreen.boxesFilter.body.placement.toPartner')
                      "
                    />
                    <basic-select-item
                      :value="3"
                      :text="
                        $t('storeScreen.boxesFilter.body.placement.inStore')
                      "
                    />
                  </basic-select>
                </div>
              </div>
              <div class="filter">
                <auto-complete
                  :keys="partners.map(x => x.id)"
                  :values="partners.map(item => item.name)"
                  v-model="partnerID"
                  :placeholderText="
                    $t('deliveryScreen.partnerPicker.partnerSelect')
                  "
                  :label="$t('deliveryScreen.partnerPicker.partnerSelect')"
                  :canAddNewOption="false"
                  :keepOpen="false"
                />
                <!-- <basic-select
                  :placeholderText="$t('storeScreen.boxesFilter.body.partner')"
                  :label="$t('storeScreen.boxesFilter.body.partner')"
                  class="type-input"
                  v-model="partnerID"
                >
                  <basic-select-item
                    v-for="(item, index) in partners"
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                  />
                </basic-select> -->
              </div>
              <div class="type">
                <basic-select
                  :placeholderText="$t('storeScreen.boxesFilter.body.type')"
                  :label="$t('storeScreen.boxesFilter.body.type')"
                  class="type-input"
                  v-model="type"
                >
                  <basic-select-item
                    :value="0"
                    :text="$variables.boxTypes[0]"
                  />
                  <basic-select-item
                    :value="1"
                    :text="$variables.boxTypes[1]"
                  />
                  <basic-select-item
                    :value="2"
                    :text="$variables.boxTypes[2]"
                  />
                </basic-select>
              </div>
              <div class="qr-filter-wrapper">
                <basic-input
                  type="number"
                  :label="$t('storeScreen.boxesFilter.body.qrFilter')"
                  :placeholder="$t('storeScreen.boxesFilter.body.qrFilter')"
                  class="qr-filter"
                  v-model="qrFilter"
                />
              </div>
              <div class="type">
                <basic-switch
                  :afterText="
                    $t('storeScreen.boxesFilter.body.hideBoxesInStore')
                  "
                  v-model="hideBoxesInStore"
                />
              </div>
            </div>
            <div class="button-wrapper">
              <rounded-button
                buttonType="danger"
                :isOutline="true"
                width="45%"
                class="button"
                position="left"
                @click="removeFilter"
              >
                {{ $t("storeScreen.boxesFilter.body.removeFilter") }}
              </rounded-button>
              <rounded-button
                width="45%"
                @click="filterData"
                class="button"
                position="right"
              >
                {{ $t("storeScreen.boxesFilter.body.filterButton") }}
              </rounded-button>
            </div>
          </div>
        </template>
      </template>
    </dropdown-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BoxesFilter",
  props: {},
  components: {},
  data: () => ({
    placement: undefined,
    wordFilter: undefined,
    qrFilter: undefined,
    type: undefined,
    partnerID: undefined,
    hideBoxesInStore: false,
    partners: [],
    isLoading: false
  }),
  created() {
    this.isLoading = true;
    this.getPartners();
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth"
    }),
    computedData() {
      let filter = undefined;
      if (this.placement !== undefined) {
        if (filter === undefined) {
          filter = {};
        }
        filter["placement"] = this.placement;
      }
      if (this.type !== undefined) {
        if (filter === undefined) {
          filter = {};
        }
        filter["type"] = this.type;
      }
      if (this.partnerID !== undefined) {
        if (filter === undefined) {
          filter = {};
        }
        filter["partnerID"] = this.partnerID;
      }
      if (this.wordFilter !== undefined && this.wordFilter !== "") {
        if (filter === undefined) {
          filter = {};
        }
        filter["wordFilter"] = this.wordFilter;
      }
      if (this.qrFilter !== undefined && this.qrFilter !== "") {
        if (filter === undefined) {
          filter = {};
        }
        filter["qrFilter"] = this.qrFilter;
      }
      if (this.hideBoxesInStore !== undefined && this.hideBoxesInStore !== "") {
        if (filter === undefined) {
          filter = {};
        }
        filter["hideBoxesInStore"] = this.hideBoxesInStore ? 1 : 0;
      }

      return filter;
    },
    cardIsOpen() {
      return this.getWindowWidth > 760;
    }
  },
  methods: {
    ...mapActions({
      readPartners: "partners/readPartners"
    }),
    getPartners() {
      this.readPartners()
        .then(res => {
          if (res.status === "OK") {
            this.partners = res.data;
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => (this.isLoading = false));
    },
    removeFilter() {
      this.placement = undefined;
      this.wordFilter = undefined;
      this.qrFilter = undefined;
      this.type = undefined;
      this.partnerID = undefined;
      this.$emit("clickedFilter", this.computedData);
    },
    filterData() {
      this.$emit("clickedFilter", this.computedData);
    }
  }
};
</script>

<style lang="scss" scoped>
#boxes-filter {
  margin-top: 20px;
  .dropdown-card {
    .header-part {
      display: flex;
      .header-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .header-title {
        font-weight: 550;
        color: #5a5a5a;
      }
    }
    .filter-body {
      padding-top: 10px !important;
      padding: 5px;
      .filter-wrapper {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px 15px;
        /deep/ #select-wrapper {
          .selectable-items {
            top: 0 !important;
          }
        }
        // .double-filter {
        //   display: flex;
        //   justify-content: space-between;
        //   .position {
        //     width: 65%;
        //   }
        //   .type {
        //     width: 30%;
        //   }
        // }
      }
      .button-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 25px;
        margin-bottom: 5px;
        .button {
          max-width: 200px;
        }
      }
    }
  }
}

@media (max-width: 760px) {
  .filter-wrapper {
    grid-template-columns: repeat(1, 1fr) !important;
    .double-filter {
      flex-direction: column !important;
      justify-content: unset !important;
      .position {
        width: 100% !important;
        margin-bottom: 10px !important;
      }
      .type {
        width: 100% !important;
      }
    }
  }
}
@media (max-width: 1600px) and (min-width: 761px) {
  .filter-wrapper {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: 1900px) and (min-width: 1601px) {
  .filter-wrapper {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
@media (min-width: 1901px) {
  .filter-wrapper {
    grid-template-columns: repeat(4, 1fr) !important;
  }
}
</style>
